// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2857": "bf1774820af0","3636": "dbfc89bc969b","366": "cf7f42d90105","7140": "aa4de7e5ab00","8448": "8f0b63be48fc","8966": "e505230bd60b",}[chunkId] + ".css"
}